<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="card">

    <!-- Cabecera -->
    <div class="card-header card-header-toolbar">

      <!-- Filtros -->
      <div class="toolbar-filters">

        <!-- Perfil -->
        <select class="form-control filter-select"
                [(ngModel)]="selectedRole"
                (change)="onRoleFilterChange()">
          <option value="">Todos los perfiles</option>
          <option *ngFor="let p of profilesList" [value]="p.key">{{ p.title }}</option>
        </select>

        <!-- Buscador -->
        <div class="input-group search-input">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0">
              <i class="fa fa-search text-muted"></i>
            </span>
          </div>
          <input type="text"
                 class="form-control border-left-0"
                 placeholder="Buscar por nombre, correo o teléfono"
                 [(ngModel)]="textSearch"
                 (keyup.enter)="getResults()">
          <div class="input-group-append">
            <button class="btn btn-primary px-3" (click)="getResults()">Buscar</button>
            <button class="btn btn-outline-secondary"
                    *ngIf="textSearch"
                    (click)="clearInputs()"
                    title="Limpiar">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

      </div>

      <!-- Acción principal -->
      <button *ngIf="canCreateUser()"
              class="btn btn-success btn-new" (click)="openNuevoUsuario()">
        <i class="fa fa-user-plus mr-1"></i> Nuevo usuario
      </button>

    </div>

    <div class="card-body">
      <div id="batchDelete">
        <div class="table-responsive">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
            class="table table-lg table-hover row-border hover">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Correo electrónico</th>
                <th>Teléfono</th>
                <th>Perfil</th>
                <th class="text-center">Cuenta activa</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of admin_list">
                <td>{{user.firstName}} {{user.lastName}}</td>
                <td>{{user.email}}</td>
                <td>{{!user.phoneNumber ? 'Sin número' : user.phoneNumber}}</td>
                <td>{{ getProfileTitle(user) }}</td>
                <td class="text-center">
                  <span class="badge" [ngClass]="user.Active ? 'badge-success' : 'badge-secondary'">
                    {{ user.Active ? 'Activa' : 'Inactiva' }}
                  </span>
                </td>
                <td>
                  <span *ngIf="canEditUser()"
                        (click)="openEditarUsuario(user)" title="Editar usuario" class="pointer mr-2">
                    <i class="fa fa-edit"></i>
                  </span>
                  <span *ngIf="canEditUser()"
                        (click)="openActualizarContrasena(user)" title="Actualizar contraseña" class="pointer mr-2">
                    <i class="fa fa-lock"></i>
                  </span>
                  <span *ngIf="canEditUser()"
                        (click)="confirmToggleActive(user)" class="pointer mr-2"
                        [title]="user.Active ? 'Desactivar cuenta' : 'Activar cuenta'">
                    <i class="fa" [ngClass]="user.Active ? 'fa-toggle-on text-success' : 'fa-toggle-off text-secondary'"></i>
                  </span>
                  <span *ngIf="canDeleteUser()"
                        (click)="setModalDeleteContent(contentDelete, user.id)" title="Borrar usuario" class="pointer">
                    <i class="fa fa-trash"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <ngb-pagination (pageChange)="loadPage($event)" [collectionSize]="total" [(page)]="page"
            [maxSize]="10" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- Container-fluid Ends-->

<!-- ── Modal: Eliminar usuario ──────────────────────────────────────────── -->
<ng-template #contentDelete let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Eliminar usuario</h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <i class="fa fa-exclamation-triangle fa-3x text-danger mb-3"></i>
    <p>Se eliminará permanentemente este usuario.</p>
    <p class="text-muted small">Esta acción no se puede deshacer.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.close()">Cancelar</button>
    <button type="button" class="btn btn-danger" (click)="deleteUser()">Eliminar</button>
  </div>
</ng-template>

<!-- ── Modal: Confirmar activar / desactivar ──────────────────────────────── -->
<ng-template #modalToggleActive let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa mr-2"
         [ngClass]="selectedUser?.Active ? 'fa-toggle-off text-secondary' : 'fa-toggle-on text-success'"></i>
      {{ selectedUser?.Active ? 'Desactivar cuenta' : 'Activar cuenta' }}
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>
  <div class="modal-body text-center">
    <p *ngIf="selectedUser?.Active">
      Se <strong>desactivará</strong> la cuenta de
      <strong>{{ selectedUser?.firstName }} {{ selectedUser?.lastName }}</strong>.
      El usuario no podrá iniciar sesión hasta que sea reactivado.
    </p>
    <p *ngIf="!selectedUser?.Active">
      Se <strong>activará</strong> la cuenta de
      <strong>{{ selectedUser?.firstName }} {{ selectedUser?.lastName }}</strong>.
      El usuario podrá iniciar sesión nuevamente.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn"
            [ngClass]="selectedUser?.Active ? 'btn-warning' : 'btn-success'"
            [disabled]="isSaving"
            (click)="doToggleActive(modal)">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ selectedUser?.Active ? 'Desactivar' : 'Activar' }}
    </button>
  </div>
</ng-template>

<!-- ── Modal: Editar usuario ─────────────────────────────────────────────── -->
<ng-template #modalEditarUsuario let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-edit mr-2 text-primary"></i>Editar usuario
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>

  <div class="modal-body" [formGroup]="editUserForm">

    <div class="form-row">
      <!-- Nombre -->
      <div class="form-group col-md-6">
        <label>Nombre <span class="text-danger">*</span></label>
        <input type="text" class="form-control"
               formControlName="firstName"
               placeholder="Nombre(s)"
               [class.is-invalid]="isInvalidEdit('firstName')">
        <div class="invalid-feedback">Ingresa el nombre.</div>
      </div>

      <!-- Apellido -->
      <div class="form-group col-md-6">
        <label>Apellido <span class="text-danger">*</span></label>
        <input type="text" class="form-control"
               formControlName="lastName"
               placeholder="Apellido(s)"
               [class.is-invalid]="isInvalidEdit('lastName')">
        <div class="invalid-feedback">Ingresa el apellido.</div>
      </div>
    </div>

    <!-- Teléfono -->
    <div class="form-group">
      <label>Teléfono</label>
      <input type="tel" class="form-control"
             formControlName="phoneNumber"
             placeholder="10 dígitos"
             maxlength="10"
             [class.is-invalid]="isInvalidEdit('phoneNumber')">
      <div class="invalid-feedback">Ingresa un número de 10 dígitos.</div>
    </div>

    <!-- Correo electrónico -->
    <div class="form-group">
      <label>Correo electrónico <span class="text-danger">*</span></label>
      <input type="email" class="form-control"
             formControlName="email"
             placeholder="correo@ejemplo.com"
             [class.is-invalid]="isInvalidEdit('email')">
      <div class="invalid-feedback">Ingresa un correo válido.</div>
    </div>

    <!-- Perfil de usuario -->
    <div class="form-group">
      <label>Perfil de usuario <span class="text-danger">*</span></label>
      <ng-select
        formControlName="roles"
        [items]="profilesList"
        bindLabel="title"
        bindValue="key"
        placeholder="Selecciona un perfil"
        [clearable]="false"
        [class.is-invalid]="isInvalidEdit('roles')">
      </ng-select>
      <div class="invalid-feedback d-block" *ngIf="isInvalidEdit('roles')">Selecciona un perfil.</div>
    </div>

    <!-- Área -->
    <div class="form-group">
      <label>Área</label>
      <ng-select
        formControlName="area"
        [items]="departments"
        placeholder="Selecciona un área (opcional)">
      </ng-select>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="isSaving" (click)="saveEditarUsuario(modal)">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ isSaving ? 'Guardando...' : 'Guardar cambios' }}
    </button>
  </div>
</ng-template>

<!-- ── Modal: Actualizar contraseña ─────────────────────────────────────── -->
<ng-template #modalActualizarContrasena let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-lock mr-2 text-warning"></i>Actualizar contraseña
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>

  <div class="modal-body modal-body-password" [formGroup]="passwordForm">

    <div class="user-info-badge" *ngIf="selectedUser">
      <i class="fa fa-user-circle mr-1"></i>
      <span><strong>{{ selectedUser.firstName }} {{ selectedUser.lastName }}</strong></span>
      <span class="user-email">{{ selectedUser.email }}</span>
    </div>

    <!-- Nueva contraseña -->
    <div class="form-group mt-3">
      <label class="form-label-sm">Nueva contraseña <span class="text-danger">*</span></label>
      <div class="pwd-input-wrap" [class.is-invalid-wrap]="isInvalidPwd('password')">
        <input [type]="showNewPassword ? 'text' : 'password'"
               class="form-control pwd-field"
               formControlName="password"
               placeholder="Mínimo 8 caracteres"
               autocomplete="new-password">
        <button type="button" class="pwd-toggle" tabindex="-1"
                (click)="showNewPassword = !showNewPassword">
          <i class="fa" [ngClass]="showNewPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>
      <div class="field-error" *ngIf="isInvalidPwd('password')">
        La contraseña debe tener al menos 8 caracteres.
      </div>
    </div>

    <!-- Confirmar contraseña -->
    <div class="form-group">
      <label class="form-label-sm">Confirmar contraseña <span class="text-danger">*</span></label>
      <div class="pwd-input-wrap" [class.is-invalid-wrap]="isInvalidPwd('confirmPassword') || passwordMismatch">
        <input [type]="showConfirmPassword ? 'text' : 'password'"
               class="form-control pwd-field"
               formControlName="confirmPassword"
               placeholder="Repite la contraseña"
               autocomplete="new-password">
        <button type="button" class="pwd-toggle" tabindex="-1"
                (click)="showConfirmPassword = !showConfirmPassword">
          <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>
      <div class="field-error" *ngIf="isInvalidPwd('confirmPassword') || passwordMismatch">
        Las contraseñas no coinciden.
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-warning text-white" [disabled]="isSaving"
            (click)="saveActualizarContrasena(modal)">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ isSaving ? 'Guardando...' : 'Actualizar contraseña' }}
    </button>
  </div>
</ng-template>

<!-- ── Modal: Nuevo usuario ──────────────────────────────────────────────── -->
<ng-template #modalNuevoUsuario let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-user-plus mr-2 text-success"></i>Nuevo usuario
    </h5>
    <button type="button" class="close" (click)="modal.dismiss()"><span>&times;</span></button>
  </div>

  <div class="modal-body" [formGroup]="newUserForm">

    <div class="form-row">
      <!-- Nombre -->
      <div class="form-group col-md-6">
        <label>Nombre <span class="text-danger">*</span></label>
        <input type="text" class="form-control"
               formControlName="firstName"
               placeholder="Nombre(s)"
               [class.is-invalid]="isInvalid('firstName')">
        <div class="invalid-feedback">Ingresa el nombre.</div>
      </div>

      <!-- Apellido -->
      <div class="form-group col-md-6">
        <label>Apellido <span class="text-danger">*</span></label>
        <input type="text" class="form-control"
               formControlName="lastName"
               placeholder="Apellido(s)"
               [class.is-invalid]="isInvalid('lastName')">
        <div class="invalid-feedback">Ingresa el apellido.</div>
      </div>
    </div>

    <!-- Teléfono -->
    <div class="form-group">
      <label>Teléfono</label>
      <input type="tel" class="form-control"
             formControlName="phoneNumber"
             placeholder="10 dígitos"
             maxlength="10"
             [class.is-invalid]="isInvalid('phoneNumber')">
      <div class="invalid-feedback">Ingresa un número de 10 dígitos.</div>
    </div>

    <!-- Correo electrónico -->
    <div class="form-group">
      <label>Correo electrónico <span class="text-danger">*</span></label>
      <input type="email" class="form-control"
             formControlName="email"
             placeholder="correo@ejemplo.com"
             [class.is-invalid]="isInvalid('email')">
      <div class="invalid-feedback">Ingresa un correo válido.</div>
    </div>

    <!-- Perfil de usuario -->
    <div class="form-group">
      <label>Perfil de usuario <span class="text-danger">*</span></label>
      <ng-select
        formControlName="roles"
        [items]="profilesList"
        bindLabel="title"
        bindValue="key"
        placeholder="Selecciona un perfil"
        [clearable]="false"
        [class.is-invalid]="isInvalid('roles')">
      </ng-select>
      <div class="invalid-feedback d-block" *ngIf="isInvalid('roles')">Selecciona un perfil.</div>
    </div>

    <!-- Área -->
    <div class="form-group">
      <label>Área</label>
      <ng-select
        formControlName="area"
        [items]="departments"
        placeholder="Selecciona un área (opcional)">
      </ng-select>
    </div>

    <!-- Contraseña -->
    <div class="form-group">
      <label>Contraseña <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          [type]="showPassword ? 'text' : 'password'"
          class="form-control"
          formControlName="password"
          placeholder="Mínimo 8 caracteres"
          [class.is-invalid]="isInvalid('password')">
        <div class="input-group-append">
          <button type="button" class="btn btn-outline-secondary"
                  (click)="showPassword = !showPassword"
                  tabindex="-1">
            <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
          </button>
        </div>
        <div class="invalid-feedback">La contraseña debe tener al menos 8 caracteres.</div>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-success" [disabled]="isSaving" (click)="saveNuevoUsuario(modal)">
      <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-1"></span>
      {{ isSaving ? 'Guardando...' : 'Crear usuario' }}
    </button>
  </div>
</ng-template>
